import React from 'react';

function SocialMediaCtaSection() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="social-media-cta-section">
      {/* Background Ambient Glow */}
      <div className="social-cta-bg-glow"></div>

      <div className="container social-cta-container">
        {/* Left Column: Heading, Subtitle & Button */}
        <div className="social-cta-left">
          <h2 className="social-cta-title">
            Claim Your <span style={{ color: '#c40a0a' }}>Personalized Social Media Strategy</span> Today
          </h2>

          <p className="social-cta-desc">
            Partner with Pakistan's leading social media marketing agency to boost your brand reach, create engaging content, and generate profitable returns.
          </p>

          <button className="btn-social-cta-quote" onClick={handleQuoteClick}>
            <span>Get free quote now!</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>

        {/* Right Column: Floating Graphic */}
        <div className="social-cta-right">
          <div className="social-cta-img-wrapper">
            <img
              src="/assets/images/social-media/social-img6.webp"
              alt="Claim Your Personalized Social Media Strategy Today"
              className="social-cta-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMediaCtaSection;
